var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('a-button',{attrs:{"type":"link"},on:{"click":_vm.handlePageJump}},[_vm._v("请到新标签页查看")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }